import React from 'react'
import { Link } from 'react-router-dom'
import { alpha, Box, Button, Container, Divider, Grid, IconButton, Stack, Typography } from '@mui/material'
import { ArrowForward, Email, Instagram, LinkedIn, Phone } from '@mui/icons-material'

const Footer = () => {
    const currentYear = new Date().getFullYear()

    return (
        <Box sx={{
            borderTop: `1px solid ${alpha('#675944', 0.1)}`,
            background: 'linear-gradient(135deg, #FDFDFB 0%, #FAF8F5 100%)',
            backdropFilter: 'blur(20px)',
            mt: 'auto',
        }}>
            <Container maxWidth="xl">
                <Box sx={{py: {xs: 2, md: 3}}}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={4}>
                            <Box sx={{display: 'flex', alignItems: 'center', gap: 0}}>
                                <Box
                                    component="img"
                                    src='/images/ImseenNBGLogo.png'
                                    alt='Imseen Interiors Logo'
                                    loading="lazy"
                                    sx={{
                                        width: {xs: '100px', sm: '120px', md: '150px'},
                                        height: {xs: '130px', sm: '160px', md: '200px'},
                                        objectFit: 'cover',
                                        mt: {xs: -5, sm: -6, md: -8},
                                        mb: {xs: -5, sm: -6, md: -8},
                                        ml: {xs: 0, sm: 1, md: 2},
                                        alignSelf: 'center',
                                    }}
                                />
                            </Box>
                            <Box sx={{alignSelf: 'center', textAlign: 'flex-start', mb: 3}}>
                                <Typography variant="body2" sx={{
                                    color: '#666',
                                    fontFamily: '"Inter", sans-serif',
                                    fontSize: '0.875rem'
                                }}>
                                    Where Your Vision is Seen
                                </Typography>
                            </Box>

                            <Button
                                component={Link}
                                to="/contact"
                                variant="contained"
                                endIcon={<ArrowForward/>}
                                sx={{
                                    backgroundColor: '#675944',
                                    color: '#FDFDFB',
                                    borderRadius: '6px',
                                    px: 3,
                                    py: 1,
                                    fontSize: '0.9rem',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    fontFamily: '"Inter", sans-serif',
                                    letterSpacing: '0.02em',
                                    '&:hover': {
                                        backgroundColor: '#574732',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 4px 12px rgba(103, 89, 68, 0.3)'
                                    },
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                Start Your Project
                            </Button>
                        </Grid>

                        <Grid item xs={6} md={2}>
                            <Typography variant="h6" sx={{
                                color: '#1A1A1A',
                                mb: 2,
                                fontWeight: 500,
                                fontSize: '1rem',
                                fontFamily: '"Inter", sans-serif'
                            }}>
                                Navigation
                            </Typography>
                            <Stack spacing={1}>
                                {[
                                    {to: '/', label: 'Home'},
                                    {to: '/about', label: 'Our Story'},
                                    {to: '/portfolio', label: 'Portfolio'},
                                    {to: '/services', label: 'Services'},
                                    {to: '/contact', label: 'Contact'}
                                ].map((link) => (
                                    <Button
                                        key={link.to}
                                        component={Link}
                                        to={link.to}
                                        sx={{
                                            justifyContent: 'flex-start',

                                            alignItems: 'center',
                                            color: '#666',
                                            textTransform: 'none',
                                            fontSize: '0.85rem',
                                            fontWeight: 400,
                                            p: 0,
                                            borderRadius: '20px',
                                            fontFamily: '"Inter", sans-serif',
                                            maxWidth: '70px',

                                            '&:hover': {
                                                color: '#675944',
                                                transform: 'scale(1.05)',
                                                backgroundColor: alpha('#675944', 0.05),
                                            },
                                            transition: 'all 0.3s ease',
                                        }}
                                    >
                                        {link.label}
                                    </Button>
                                ))}
                            </Stack>
                        </Grid>

                        <Grid item xs={6} md={2}>
                            <Typography variant="h6" sx={{
                                color: '#1A1A1A',
                                mb: 2,
                                fontWeight: 500,
                                fontSize: '1rem',
                                fontFamily: '"Inter", sans-serif'
                            }}>
                                Expertise
                            </Typography>
                            <Stack spacing={1}>
                                {[
                                    'Residential Design',
                                    'Home Staging',
                                    'Space Planning',
                                    'Color Consultation',
                                    'Brand Collaboration'
                                ].map((service) => (
                                    <Typography
                                        key={service}
                                        variant="body1"
                                        sx={{
                                            color: '#666',
                                            fontSize: '0.85rem',
                                            fontFamily: '"Inter", sans-serif',
                                            fontWeight: 400,
                                            '&:hover': {
                                                color: '#675944',
                                                cursor: 'pointer',
                                                transform: 'translateX(2px)'
                                            },
                                            transition: 'all 0.3s ease'
                                        }}
                                    >
                                        {service}
                                    </Typography>
                                ))}
                            </Stack>
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Typography variant="h6" sx={{
                                color: '#1A1A1A',
                                mb: 2,
                                fontWeight: 500,
                                fontSize: '1rem',
                                fontFamily: '"Inter", sans-serif'
                            }}>
                                Let's Connect
                            </Typography>

                            <Stack spacing={1} sx={{mb: 3}}>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                    <Email sx={{color: '#675944', fontSize: 18}}/>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#666',
                                            fontSize: '0.85rem',
                                            fontFamily: '"Inter", sans-serif'
                                        }}
                                    >
                                        Juleen@imseen-interiors.com
                                    </Typography>
                                </Box>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                    <Phone sx={{color: '#675944', fontSize: 18}}/>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#666',
                                            fontSize: '0.85rem',
                                            fontFamily: '"Inter", sans-serif'
                                        }}
                                    >
                                        +1 (240) 316-1208
                                    </Typography>
                                </Box>
                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                    {[
                                        {
                                            icon: <Instagram/>,
                                            color: '#675944',
                                            link: 'https://www.instagram.com/juleen_imseeh/'
                                        },
                                        {
                                            icon: <LinkedIn/>,
                                            color: '#675944',
                                            link: 'https://www.linkedin.com/in/juleen-imsseeh/'
                                        }
                                    ].map((social, index) => (
                                        <IconButton
                                            key={index}
                                            onClick={() => window.open(social.link, '_blank')}
                                            sx={{
                                                mt: 2,
                                                color: '#675944',
                                                bgcolor: alpha('#675944', 0.05),
                                                border: `1px solid ${alpha('#675944', 0.2)}`,
                                                '&:hover': {
                                                    bgcolor: alpha('#675944', 0.1),
                                                    transform: 'translateY(-1px)',
                                                    boxShadow: `0 2px 8px ${alpha('#675944', 0.2)}`
                                                },
                                                transition: 'all 0.3s ease',
                                                padding: '6px'
                                            }}
                                            size="small"
                                        >
                                            {social.icon}
                                        </IconButton>
                                    ))}
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>

                <Divider sx={{
                    bgcolor: alpha('#675944', 0.1),
                    height: '1px'
                }}/>

                <Box sx={{
                    py: 2,
                    textAlign: 'center',
                }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#666',
                            fontSize: '0.8rem',
                            letterSpacing: '0.02em',
                            fontFamily: '"Inter", sans-serif'
                        }}
                    >
                        © {currentYear} IMSEEN INTERIORS. Where Your Vision is Seen.
                    </Typography>
                    <Typography
                        variant="caption"
                        sx={{
                            color: '#999',
                            display: 'block',
                            mt: 0.5,
                            fontSize: '0.75rem',
                            fontFamily: '"Inter", sans-serif'
                        }}
                    >
                        All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    )
}

export default Footer
